import React, { useState } from 'react';
import { Bell, Search, HelpCircle, Settings, LogOut, User, Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
const Header = ({
  onMenuClick
}) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const navigate = useNavigate();
  const {
    user,
    logout
  } = useAuth();
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  return <header className="border-b border-gray-100 bg-white shadow-sm" data-id="element-296">
      <div className="flex h-16 items-center justify-between px-4 md:px-6" data-id="element-297">
        {/* Mobile menu button only */}
        <div className="flex items-center" data-id="element-298">
          <button className="lg:hidden p-2 rounded-md hover:bg-gray-100" onClick={onMenuClick} data-id="element-299">
            <Menu size={24} data-id="element-300" />
          </button>
        </div>
        <div className="flex items-center gap-4 flex-1 justify-end lg:justify-end" data-id="element-301">
          {/* Search bar - hidden on mobile by default */}
          <div className={`${showSearch ? 'absolute inset-x-0 top-0 p-4 bg-white z-10 h-16 flex items-center' : 'hidden'} md:relative md:block md:w-full md:max-w-md`} data-id="element-302">
            {showSearch && <button className="absolute right-6 top-1/2 -translate-y-1/2 md:hidden" onClick={() => setShowSearch(false)} data-id="element-303">
                <X size={20} data-id="element-304" />
              </button>}
            <div className="relative w-full" data-id="element-305">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-306" />
              <input type="text" placeholder="Search..." className="h-10 w-full rounded-md border border-gray-200 bg-white pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#4169e1] focus:border-transparent" data-id="element-307" />
            </div>
          </div>
          {/* Mobile search button */}
          <button className="md:hidden p-2 rounded-md hover:bg-gray-100" onClick={() => setShowSearch(true)} data-id="element-308">
            <Search size={20} data-id="element-309" />
          </button>
        </div>
        <div className="flex items-center gap-2 md:gap-4" data-id="element-310">
          <div className="relative" data-id="element-311">
            <button className="flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100 transition-colors" onClick={() => {
            setShowNotifications(!showNotifications);
            setShowProfileMenu(false);
          }} data-id="element-312">
              <Bell size={18} data-id="element-313" />
              <span className="absolute top-0 right-0 h-2 w-2 rounded-full bg-red-500" data-id="element-314"></span>
            </button>
            {showNotifications && <div className="absolute right-0 mt-2 w-[calc(100vw-2rem)] sm:w-80 bg-white rounded-md shadow-lg border border-gray-200 z-50" data-id="element-315">
                <div className="p-3 border-b border-gray-100" data-id="element-316">
                  <div className="flex items-center justify-between" data-id="element-317">
                    <h3 className="font-medium text-sm" data-id="element-318">Notifications</h3>
                    <span className="text-xs text-blue-600 cursor-pointer" data-id="element-319">
                      Mark all as read
                    </span>
                  </div>
                </div>
                <div className="max-h-96 overflow-y-auto" data-id="element-320">
                  <div className="p-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer" data-id="element-321">
                    <div className="flex gap-3" data-id="element-322">
                      <div className="h-9 w-9 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-323">
                        <Bell size={16} className="text-blue-600" data-id="element-324" />
                      </div>
                      <div data-id="element-325">
                        <p className="text-sm font-medium" data-id="element-326">
                          New patient registration
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-327">
                          Sarah Mitchell completed registration
                        </p>
                        <p className="text-xs text-gray-400 mt-1" data-id="element-328">
                          10 minutes ago
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer" data-id="element-329">
                    <div className="flex gap-3" data-id="element-330">
                      <div className="h-9 w-9 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-331">
                        <Bell size={16} className="text-green-600" data-id="element-332" />
                      </div>
                      <div data-id="element-333">
                        <p className="text-sm font-medium" data-id="element-334">
                          Registration verified
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-335">
                          James Cooper's registration approved
                        </p>
                        <p className="text-xs text-gray-400 mt-1" data-id="element-336">
                          25 minutes ago
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-2 border-t border-gray-100 text-center" data-id="element-337">
                  <button className="text-sm text-blue-600 hover:underline" data-id="element-338">
                    View all notifications
                  </button>
                </div>
              </div>}
          </div>
          <div className="h-8 w-px bg-gray-200 hidden sm:block" data-id="element-339"></div>
          <div className="flex items-center gap-3" data-id="element-340">
            <button className="hidden sm:flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100 transition-colors" data-id="element-341">
              <HelpCircle size={18} data-id="element-342" />
            </button>
            <div className="relative" data-id="element-343">
              <div className="flex items-center gap-2 sm:gap-3 cursor-pointer" onClick={() => {
              setShowProfileMenu(!showProfileMenu);
              setShowNotifications(false);
            }} data-id="element-344">
                <div className="h-8 w-8 rounded-full bg-black flex items-center justify-center text-white text-xs font-medium" data-id="element-345">
                  {user?.name?.split(' ').map(n => n[0]).join('') || 'AU'}
                </div>
                <div className="hidden sm:block" data-id="element-346">
                  <div className="text-sm font-medium" data-id="element-347">
                    {user?.name || 'Admin User'}
                  </div>
                  <div className="text-xs text-muted-foreground" data-id="element-348">
                    {user?.role || 'Administrator'}
                  </div>
                </div>
              </div>
              {showProfileMenu && <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-50" data-id="element-349">
                  <div className="p-3 border-b border-gray-100" data-id="element-350">
                    <div className="flex items-center gap-3" data-id="element-351">
                      <div className="h-10 w-10 rounded-full bg-[#4169e1] flex items-center justify-center text-white text-sm font-medium" data-id="element-352">
                        {user?.name?.split(' ').map(n => n[0]).join('') || 'AU'}
                      </div>
                      <div data-id="element-353">
                        <div className="font-medium" data-id="element-354">
                          {user?.name || 'Admin User'}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-355">
                          {user?.email || 'admin@novocuris.com'}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="py-1" data-id="element-356">
                    <button className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-357">
                      <User size={16} data-id="element-358" />
                      <span data-id="element-359">Manage Profile</span>
                    </button>
                    <button className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-360">
                      <Settings size={16} data-id="element-361" />
                      <span data-id="element-362">Settings</span>
                    </button>
                    <button className="flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100" onClick={handleLogout} data-id="element-363">
                      <LogOut size={16} data-id="element-364" />
                      <span data-id="element-365">Log Out</span>
                    </button>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;